export const useDatabaseName = () => {
  const pathSegments = window.location.pathname.split("/").filter(Boolean);
  return pathSegments.length > 0 && !pathSegments.includes('selecao') ? pathSegments[0] : null;
};
